module.exports = __webpack_public_path__ + "img/26.fb2fef4e.png";